import React from "react";
import {useNavigate } from "react-router-dom";

const LoginButton = ({ onLogin }) => {
  const navigate = useNavigate();

  const handleLogin = () => {
    window.FB.login(
      (response) => {
        if (response.authResponse) {
          const { accessToken } = response.authResponse;

          // ตรวจสอบและบันทึก Access Token
          if (!accessToken) {
            alert("Access Token not found. Please try logging in again.");
            return;
          }
          localStorage.setItem("facebookAccessToken", accessToken);
          console.log("Access Token:", accessToken);

          // ดึงข้อมูลผู้ใช้
          window.FB.api("/me", { fields: "name,email" }, (userData) => {
            if (userData) {
              localStorage.setItem("facebookUser", JSON.stringify(userData));
              console.log("User Data:", userData);
              onLogin(userData);

              // ดึง Page Access Token
              window.FB.api("/me/accounts", (pageData) => {
                if (pageData && pageData.data && pageData.data.length > 0) {
                  const pageAccessToken = pageData.data[0].access_token;
                  localStorage.setItem(
                    "facebookPageAccessToken",
                    pageAccessToken
                  );
                  console.log("Page Access Token:", pageAccessToken);
                } else {
                  console.warn("No pages found or insufficient permissions.");
                  alert(
                    pageData && pageData.data
                      ? "You do not manage any Facebook pages."
                      : "Unable to fetch Page Access Token. Please check permissions."
                  );
                }
              });
            } else {
              alert("Unable to fetch user data. Please try again.");
            }
          });
        } else {
          alert("Login failed or user cancelled login.");
          navigate("/"); // เพิ่มการนำผู้ใช้กลับไปหน้า "/"
        }
      },
      {
        scope:
          "public_profile,email,pages_show_list,pages_read_engagement,pages_read_user_content",
      }
    );
  };

  return (
    <div className="text-center">
      <h1 className="text-3xl font-bold text-white mb-2">PublicLink Insights</h1>
      <p className="text-white mb-6">Analyze and track your Facebook page performance.</p>
      <button
        onClick={handleLogin}
        className="bg-gradient-to-r from-blue-500 to-purple-600 text-white px-6 py-3 rounded-lg shadow-lg font-semibold transition duration-300 transform hover:scale-105 hover:shadow-2xl"
      >
        <span className="flex items-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="white"
            className="w-5 h-5 mr-2"
          >
            <path
              d="M12 2.04C6.48 2.04 2 6.52 2 12s4.48 9.96 10 9.96c5.22 0 9.45-3.94 10-9.03h-4.3v3.48H12V11.4h4.8l-1.18-4.8H12V5.96c0-1.07.52-1.8 1.8-1.8h1.8V2.04H12z"
            />
          </svg>
          Login with Facebook
        </span>
      </button>
    </div>
  );
};

export default LoginButton;
